import { DataTransferService } from 'src/app/shared/services/common/datatransfer.service';
import { Component, EventEmitter, OnInit, TemplateRef, ViewChild, Inject } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { GlobalConstants } from 'src/app/pages/common/global-variables';
import { ApiService } from 'src/app/pages/common/api.service';
import { DOCUMENT } from '@angular/common';
import { SpecialProjectCheck } from 'src/app/shared/services/common/special-project-check';

export interface offer {
  id: string,
  merchantLogoUrl: string,
  offerType: string,
  endDate: string,
  merchantName: string,
  redemptionUrl: string,
  offerTitle: string,
  zambiaPayload?: object
}

@Component({
  selector: 'app-coupon-modal',
  templateUrl: './coupon-modal.component.html',
  styleUrls: ['./coupon-modal.component.scss'],
  providers: [ApiService]
})
export class CouponModalComponent implements OnInit {
  redeemResponseEvent: EventEmitter<any> = new EventEmitter();
  paymentLoad = false;
  selectedOffer: offer;
  copiedCode: boolean = false;
  couponLoading: boolean;

  redeemActive: boolean = false;
  redeeming = false;
  voucherData:any = {};
  currentCard:any;
  public projectCode: string = '';

  emitRedeem = new EventEmitter<boolean>();

  constructor(public GlobalConstants: GlobalConstants,
    private _apiService: ApiService,
    private toastr: ToastrService,
    public _bsModalRef: BsModalRef,
    private dataTransferService: DataTransferService,
    @Inject(DOCUMENT) private document: any,
    private specialProjectCheck: SpecialProjectCheck
  ) { }

  ngOnInit(): void {
    this.proceedToRedeem();
    if (this.specialProjectCheck.checkProject().type === 'special') {
      this.projectCode = this.specialProjectCheck.checkProject().code;
    }
  }

  proceedToRedeem() {
    this.couponLoading = true;
    let params = {}
    if (localStorage.getItem('cardSelected')) {
      params = JSON.parse(localStorage.getItem('cardSelected'));
    }
    if (this.selectedOffer.zambiaPayload){
      params = { ...params, ...this.selectedOffer.zambiaPayload };
    }
    
    this._apiService.redeem({ id: this.selectedOffer.id }, params).subscribe(
      (res: any) => {
        this.couponLoading = false;
        this.voucherData = res;
        if(this.voucherData?.voucher_code?.includes('https')) {
          this.selectedOffer.redemptionUrl = this.voucherData.voucher_code;
        }
        this.redeemResponseEvent.emit({
          response: 'success'
        })
      },
      (err) => {

        this.couponLoading = false;
        if(err.status && err.status === 402){

          // this.currentCard = JSON.parse(localStorage.getItem('uC'));
          this.dataTransferService.userCard$.subscribe(res => this.currentCard = res);
          this.voucherData.paymentNeeded = true;
          this.redeemResponseEvent.emit({
            response: 'payment-needed'
          })
        }
        else if (err.status && err.status === 412) {
          this.redeemResponseEvent.emit({
            response: 'failed'
          })
          this.voucherData.zambiaVerificationFailed = true;
        }
        else{
          this.redeemResponseEvent.emit({
            response: 'failed'
          })
          this.voucherData.success = false;
        }
      }
    );
  }
  getPayments(){
    this.paymentLoad = true;
    const formData: FormData = new FormData();
    formData.append("transactions_attributes[][txn_type]", 'payment_gateway');
    formData.append("transactions_attributes[][amount]", '1.0');
    formData.append("base_url", this.document.location.href);
    formData.append("vcp", 'vp');
    this._apiService.getPaymentLink(formData).subscribe(
      (res: any) => {
        this.paymentLoad = false;
        if(res.status && res.status == 'error'){
          this.voucherData.paymentNeeded = false;
          this.voucherData.success = false;
        }
        else{
          let payment = res;
          payment.payu_body.amount = this.isInteger(payment.payu_body.amount) ? payment.payu_body.amount + ".0" : payment.payu_body.amount;
          var form = document.createElement("form");
          form.setAttribute("method", "post");
          form.setAttribute("action", payment.payu_url);
          Object.keys(payment.payu_body).forEach((key) => {
            if(payment.payu_body[key]){

              var hiddenField = document.createElement("input");
              hiddenField.setAttribute("type", "hidden");
              hiddenField.setAttribute("name", key);
              hiddenField.setAttribute("value", payment.payu_body[key]);
              form.appendChild(hiddenField);
            }


          });
          document.body.appendChild(form);
          setTimeout(()=>{ form.submit(); }, 300);
        }

      },
      (err) => {

      }
    );
  }
  isInteger(x) {
    return typeof x === "number" && isFinite(x) && Math.floor(x) === x;
  }

  goTo() {
    this.redeeming = true;
    let gotourl = this.selectedOffer.redemptionUrl;
    setTimeout(() => {
      window.open(gotourl, '_blank','noopener');
      this.redeeming = false;
      this.redeemActive = false;
    }, 0)
  }

  showCopied(code) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = code;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastr.success($localize`Copied!`);
  }

}
